// Intefaces
import { CustomFrequency, Poll, PollFrequency, PollQuestion } from '../interfaces/Poll';

// Other
import { DEFAULT_ALL_WEEK_DAYS } from '../data/ConstantsPolls';
import { UserData } from '../interfaces/UserInfo';
import { getUser } from './Auth';

const compareTwoNumArrays = (a1: number[], a2: number[]) => {
    const sortedA1 = a1.sort((a, b) => a - b);
    const sortedA2 = a2.sort((a, b) => a - b);
    return sortedA1.length === sortedA2.length &&
        sortedA1.every(
            (element, index) => element === sortedA2[index]
        );
};


export const areFrequenciesEqual = (a: PollFrequency, b: PollFrequency) => {
    if (a.frecuency !== b.frecuency) return false;
    if (a.frequency_duration !== b.frequency_duration) return false;
    if (a.monthly_frequency_day !== b.monthly_frequency_day) return false;
    if (Array.isArray(a.semanal_frequency) && Array.isArray(b.semanal_frequency) && compareTwoNumArrays(a.semanal_frequency, b.semanal_frequency)) return true;
    if (a.semanal_frequency !== b.semanal_frequency) return false;
    return true;
};

export const getCustomFrequencyFromPollFrequency = (freq: PollFrequency): CustomFrequency => {

    if (freq.frecuency !== null || areFrequenciesEqual(freq, DEFAULT_ALL_WEEK_DAYS)) return 'daily';
    else if (freq.semanal_frequency !== null) return 'weekly';
    else if (freq.monthly_frequency_day !== null) return 'monthly';
    return 'daily';
};

export const getPollFrequency = (poll: PollFrequency) => {
    return {
        frecuency: poll.frecuency,
        monthly_frequency_day: poll.monthly_frequency_day,
        semanal_frequency: poll.semanal_frequency,
        frequency_duration: poll.frequency_duration
    };
};

export const getPollErrorsInputID = (poll: Poll) => {
    const inputIDs = [];
    if (poll.name === undefined || poll.name.trim() === '')
        inputIDs.push('poll_name');
    if (poll.profile_ids === undefined || poll.profile_ids === null || poll.profile_ids.length === 0)
        inputIDs.push('selector_profile');
    if (poll.questions === undefined || poll.questions.length === 0)
        inputIDs.push('questions_needed');
    return inputIDs;
};

export const getCreatePollQuestionErrors = (question: PollQuestion) => {
    if (question.description?.trim() === '') return 'no_question_statement';
    if (question.inquiry_question_type_id === 1) {
        if (question.answers.some(answer => answer.description === undefined || answer.description.trim() === '')) return 'missing_option_text';
        if (question.answers.some(answer => answer.value === undefined || answer.value === null)) return 'missing_option_value';
    }
};


export enum InquiryTypes {
    TEST = 'TEST',
    PROM = 'PROM'
}

export const getProfessionalInquiryType = (poll: Poll) =>
    poll.is_profesional_inquiry ? InquiryTypes.TEST : InquiryTypes.PROM;

export const getInquiryTypes = () =>
    [{ id: 0, content: InquiryTypes.TEST }, { id: 1, content: InquiryTypes.PROM }];

export const canUserUpdateInquiries = () => {
    const user: UserData = getUser();
    const canUpdateInquiry = user.user_roles?.some(r =>
        r.role?.permissions?.some(p => p.id === 'can_update_inquiry')
    ) ?? false;
    return canUpdateInquiry;
};
